"use client";

import React from "react";
import { motion } from "framer-motion";

export interface TalktribeCtaBlockProps {
    title?: string;
    description?: string;
}

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.7 },
};

export default function TalktribeCtaBlock({
    title = "Explore the Architecture",
    description = "TalkTribe demonstrates the power of combining natural language instructions with persistent context layers to create customized AI experiences."
}: TalktribeCtaBlockProps) {
    return (
        <section className="py-32 px-6 md:px-12 lg:px-24 bg-[#060608] border-t border-zinc-900 text-center relative overflow-hidden w-full">
            <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.005)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.005)_1px,transparent_1px)] [background-size:32px_32px] pointer-events-none" />
            <div className="container mx-auto z-10 max-w-3xl relative">
                <motion.div {...fadeUp} className="space-y-6">
                    <h2 className="text-4xl md:text-5xl font-light text-white leading-tight">{title}</h2>
                    {description && (
                        <p className="text-zinc-400 text-sm leading-relaxed max-w-lg mx-auto font-light">
                            {description}
                        </p>
                    )}
                </motion.div>
            </div>
        </section>
    );
}
